<template>
  <div class="member-area-tab-color-config-component">
    <div class="my-3">
      Cor de fundo
    </div>
    <small class="text-secondary d-block mb-6">
      Personalize a cor da sua área de membros
    </small>
    <div class="my-3 fs-14">
      Qual modo de cor você deseja?
    </div>
    <div class="row pt-6 pb-2">
      <div class="col-sm-6 cursor-pointer py-3">
        <div
          class="card-box p-5"
          :class="{ selected: form.config.style === 'dark' }"
        >
          <b-form-checkbox
            id="checkbox-dark-theme"
            class="fs-14"
            v-model="form.config.style"
            value="dark"
          >
            Modo escuro
          </b-form-checkbox>
          <div class="flex-fill">
            <img
              src="@/assets/images/member-area/dark-mode.svg"
              class="img-fluid w-100 pt-5"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-6 cursor-pointer py-3">
        <div
          class="card-box p-5"
          :class="{ selected: form.config.style === 'light' }"
        >
          <b-form-checkbox
            id="checkbox-light-theme"
            class="flex-fill fs-14"
            v-model="form.config.style"
            value="light"
          >
            Modo claro
          </b-form-checkbox>
          <div class="flex-fill">
            <img
              src="@/assets/images/member-area/light-mode.svg"
              class="img-fluid w-100 pt-5"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style>
.member-area-tab-color-config-component {
  input[type="checkbox"]:disabled {
    background-color: #fff !important;
  }
}
</style>
